import { put, select, takeLatest } from 'redux-saga/effects';
import NotificationHandler from 'utils/notification';
import { actions } from '../slices/DetailStatementOfReceiptSlice';
import { actions as summaryActions } from '../slices/SummaryStatemetOfReceiptSlice';
import { actions as cashierActions } from '../slices/CashierDepositOrderSlice';
import { actions as orderStatisticMoneyActions } from '../slices/OrderStatisticMoneySlice';
import { statementApi } from '../../../api';
import ModalHandler from 'utils/modal';

const getSearchCriteriaDetail = (state) => state.detailStatementOfReceipt.searchCriteria;
const getSearchCriteriaCashier = (state) => state.cashierDepositOrder.searchCriteria;
// Bảng kê chi tiết thu tiền

function* getCollectSalesSaga({ payload }) {
    try {
        const { getCollectSales } = statementApi;
        const { routeName, code, ...rest } = payload || {};
        const response = yield getCollectSales({ params: rest });

        if (payload?.export) {
            NotificationHandler.notifyDownloadBox(response.data);
            yield put({ type: actions.request_export_success.type });
        } else {
            yield put({ type: actions.get_list_succeed.type, payload: { ...response.data } });
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_list_failed.type, payload: error });
    }
}

function* saveCollectSalesSaga({ payload }) {
    try {
        const { saveCollectSales } = statementApi;
        const response = yield saveCollectSales({ ...payload });
        yield put({ type: actions.save_list_succeed.type, payload: { ...response.data } });
        NotificationHandler.notifySuccess('Lưu thành công');
        const searchCriteria = yield select(getSearchCriteriaDetail);
        yield put({ type: actions.get_list.type, payload: searchCriteria });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.save_list_failed.type, payload: error });
    }
}

function* getHistoryCollectSalesSaga({ payload }) {
    try {
        const { id, ...params } = payload;

        const { historyCollectSales } = statementApi;
        const response = yield historyCollectSales(id, params);
        yield put({ type: actions.save_history.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
    }
}
function* getDepositReferCollectSalesSaga({ payload }) {
    try {
        const { routeName, code, ...rest } = payload;
        const { getCollectSalesDepositRefer } = statementApi;
        const response = yield getCollectSalesDepositRefer({ params: rest });
        yield put({ type: actions.save_deposit_refer.type, payload: response.data });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
    }
}
// Bảng kê tổng hợp thu tiền
function* getSummaryConductorSaga({ payload }) {
    try {
        const { getSummaryConductor } = statementApi;
        const response = yield getSummaryConductor({ params: payload });
        yield put({ type: summaryActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: summaryActions.get_list_failed.type, payload: error });
    }
}
function* getSummaryCheckerSaga({ payload }) {
    try {
        const { getSummaryChecker } = statementApi;
        const response = yield getSummaryChecker({ params: payload });
        yield put({ type: summaryActions.get_list_checker_succeed.type, payload: response.data });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: summaryActions.get_list_checker_failed.type, payload: error });
    }
}
function* getDepositOrderCollectSalesSaga({ payload }) {
    try {
        const { getDepositOrder } = statementApi;
        const response = yield getDepositOrder({ params: payload });
        yield put({ type: summaryActions.save_deposit_order.type, payload: response.data });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
    }
}

function* saveCheckerDepositCollectSalesSaga({ payload }) {
    try {
        const { saveCheckerDeposit } = statementApi;
        yield saveCheckerDeposit({ ...payload });
        yield put({ type: summaryActions.save_checker_deposit_succeed.type });
        NotificationHandler.notifySuccess('Xác nhận thành công');
        yield ModalHandler.closeAllModal();
    } catch (error) {
        yield put({ type: summaryActions.save_checker_deposit_succeed.type });
        NotificationHandler.notifyError(error.message);
    }
}
function* depositOrderConfirmSaga({ payload }) {
    try {
        const { id, body } = payload;
        const { depositOrderConfirm } = statementApi;
        yield depositOrderConfirm(id, body);
        yield put({ type: summaryActions.deposit_order_confirm_succeed.type });
        NotificationHandler.notifySuccess('Xác nhận thành công');
        yield ModalHandler.closeAllModal();
    } catch (error) {
        yield put({ type: summaryActions.deposit_order_confirm_succeed.type });
        NotificationHandler.notifyError(error.message);
    }
}
// Thu ngân nộp ngân hàng

function* cashierDepositOrderSaga({ payload }) {
    try {
        const { cashierDepositOrder } = statementApi;
        const response = yield cashierDepositOrder({ params: payload });

        const { export: exportData } = payload || {};
        if (exportData) {
            NotificationHandler.notifyDownloadBox(response.data);
            yield put({ type: cashierActions.request_export_success.type });
        } else {
            yield put({ type: cashierActions.get_list_succeed.type, payload: { ...response.data } });
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: cashierActions.fail.type, payload: error });
    }
}

function* saveCashierDepositSaga({ payload }) {
    try {
        const { saveCashierDeposit } = statementApi;
        yield saveCashierDeposit({ ...payload });
        yield put({ type: cashierActions.save_cashier_deposit_succeed.type });

        const searchCriteria = yield select(getSearchCriteriaCashier);
        yield put({ type: cashierActions.get_list.type, payload: { ...searchCriteria } });
        NotificationHandler.notifySuccess('Xác nhận thành công');
        yield ModalHandler.closeAllModal();
    } catch (error) {
        yield put({ type: cashierActions.save_cashier_deposit_succeed.type });
        NotificationHandler.notifyError(error.message);
    }
}

function* deleteCashierDepositSaga({ payload }) {
    try {
        const { deleteCashierDeposit } = statementApi;
        yield deleteCashierDeposit(payload);
        yield put({ type: cashierActions.delete_cashier_deposit_succeed.type });
        const searchCriteria = yield select(getSearchCriteriaCashier);
        yield put({ type: cashierActions.get_list.type, payload: { ...searchCriteria } });
        NotificationHandler.notifySuccess('Xóa thành công');
        yield ModalHandler.closeAllModal();
    } catch (error) {
        yield put({ type: cashierActions.delete_cashier_deposit_succeed.type });
        NotificationHandler.notifyError(error.message);
    }
}
//

function* getOrderStatisticMoneySaga({ payload }) {
    try {
        const { getOrderStatisticMoney } = statementApi;
        const { routeName, code, ...rest } = payload || {};
        const response = yield getOrderStatisticMoney({ params: rest });

        if (payload?.export) {
            NotificationHandler.notifyDownloadBox(response.data);
            yield put({ type: orderStatisticMoneyActions.request_export_success.type });
        } else {
            yield put({ type: orderStatisticMoneyActions.get_list_succeed.type, payload: { ...response.data } });
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_list_failed.type, payload: error });
    }
}
function* watchRequestDetail() {
    yield takeLatest(actions.get_list, getCollectSalesSaga);
    yield takeLatest(actions.save_list, saveCollectSalesSaga);
    yield takeLatest(actions.get_history, getHistoryCollectSalesSaga);
    yield takeLatest(actions.get_deposit_refer, getDepositReferCollectSalesSaga);
    yield takeLatest(summaryActions.get_list, getSummaryConductorSaga);
    yield takeLatest(summaryActions.get_list_checker, getSummaryCheckerSaga);
    yield takeLatest(summaryActions.get_deposit_order, getDepositOrderCollectSalesSaga);
    yield takeLatest(summaryActions.save_checker_deposit, saveCheckerDepositCollectSalesSaga);
    yield takeLatest(summaryActions.deposit_order_confirm, depositOrderConfirmSaga);
    yield takeLatest(cashierActions.get_list, cashierDepositOrderSaga);
    yield takeLatest(cashierActions.save_cashier_deposit, saveCashierDepositSaga);
    yield takeLatest(cashierActions.delete_cashier_deposit, deleteCashierDepositSaga);
    yield takeLatest(orderStatisticMoneyActions.get_list, getOrderStatisticMoneySaga);
}

export default watchRequestDetail;
